module.exports = __webpack_public_path__ + "img/tienda.1ff74b49.png";